/* Dorabella - galleria foto nelle card di collezione (scroll-snap nativo, nessuna libreria) */
(function () {
  if (window.__doraCg) return; window.__doraCg = 1;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function track(el) { return el.querySelector('.dora-cg__track'); }
  function update(t) {
    var w = t.clientWidth || 1, i = Math.round(t.scrollLeft / w);
    var dots = t.parentNode.querySelectorAll('.dora-cg__dots i');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
  }
  // aggiorna i trattini mentre si scorre (delegato: vale anche per le card caricate dopo)
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('dora-cg__track')) {
      if (t.__raf) return;
      t.__raf = requestAnimationFrame(function () { t.__raf = 0; update(t); });
    }
  }, true);

  // desktop: frecce al passaggio del mouse
  function arrows(g) {
    if (!fine || g.__arrows) return; g.__arrows = 1;
    ['prev', 'next'].forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dora-cg__arrow dora-cg__arrow--' + d;
      b.setAttribute('aria-label', d === 'next' ? 'Foto successiva' : 'Foto precedente');
      b.innerHTML = d === 'next' ? '&#8250;' : '&#8249;';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var t = track(g); t.scrollBy({ left: (d === 'next' ? 1 : -1) * t.clientWidth, behavior: 'smooth' });
      });
      g.appendChild(b);
    });
  }
  document.addEventListener('mouseover', function (e) {
    var g = e.target.closest && e.target.closest('[data-dora-cg]'); if (g) arrows(g);
  });

  // desktop: si possono trascinare le foto con il mouse (su telefono ci pensa lo scorrimento nativo)
  if (fine) {
    var dg = null, startX = 0, startLeft = 0, moved = 0;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var t = e.target.closest && e.target.closest('.dora-cg__track');
      if (!t || t.scrollWidth <= t.clientWidth + 2) return;
      dg = t; startX = e.clientX; startLeft = t.scrollLeft; moved = 0;
      t.style.scrollSnapType = 'none'; t.style.cursor = 'grabbing';
    });
    document.addEventListener('pointermove', function (e) {
      if (!dg) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) { moved = 1; e.preventDefault(); }
      dg.scrollLeft = startLeft - dx;
    });
    var endDrag = function () {
      if (!dg) return;
      var t = dg; dg = null;
      t.style.cursor = ''; t.style.scrollSnapType = '';
      var w = t.clientWidth || 1;
      t.scrollTo({ left: Math.round(t.scrollLeft / w) * w, behavior: 'smooth' });
      if (moved) t.__dragAt = Date.now();
    };
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    // dopo un trascinamento il click non deve aprire la scheda prodotto
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.dora-cg__track');
      if (t && t.__dragAt && Date.now() - t.__dragAt < 300) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('.dora-cg__track')) e.preventDefault();
    });
  }

  // cambio colore dalla card: torna alla prima foto
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.card-product-swatch .swatch-button');
    if (!sw) return;
    var g = sw.closest('.card-product') && sw.closest('.card-product').querySelector('.dora-cg__track');
    if (g) g.scrollTo({ left: 0 });
  });

  // suggerimento stile Zara: le prime card "sbirciano" la foto successiva, una volta al giorno
  var today = new Date().toISOString().slice(0, 10), KEY = 'doraCgHintDay';
  function hintDone() { try { return localStorage.getItem(KEY) === today; } catch (e) { return false; } }
  function markHint() { try { localStorage.setItem(KEY, today); } catch (e) {} }
  if (hintDone() || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var done = 0;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting || document.visibilityState !== 'visible') return;
      io.unobserve(en.target);
      var t = track(en.target), delay = 600 + done * 400; done++;
      setTimeout(function () {
        if (!t || t.scrollLeft > 2 || document.visibilityState !== 'visible') return; // la cliente sta gia' scorrendo
        t.classList.add('is-hinting');
        t.scrollTo({ left: t.clientWidth * 0.38, behavior: 'smooth' });
        setTimeout(function () { t.scrollTo({ left: 0, behavior: 'smooth' }); }, 850);
        setTimeout(function () { t.classList.remove('is-hinting'); }, 1600);
        markHint(); // il flag si scrive solo quando l'animazione parte davvero
      }, delay);
    });
  }, { threshold: 0.6 });
  function init() {
    document.querySelectorAll('[data-dora-cg-hint]').forEach(function (g) {
      if (g.__hintObs) return; g.__hintObs = 1; io.observe(g);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // card aggiunte con "Carica di piu'" e ritorno sulla scheda
  var pend = 0;
  new MutationObserver(function () {
    if (hintDone() || pend) return;
    pend = requestAnimationFrame(function () { pend = 0; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && !hintDone()) init(); });
})();

/* Dorabella – scelta vista in collezione: Prodotto / Indossato (2a foto) / Video */
(function () {
  if (window.__doraView) return; window.__doraView = 1;
  var KEY = 'doraView', view = 'product';
  try { view = localStorage.getItem(KEY) || 'product'; } catch (e) {}
  var vio = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var g = en.target, v = g.querySelector('video.dora-cg__video');
      if (en.isIntersecting && view === 'video') {
        if (!v) {
          v = document.createElement('video');
          v.className = 'dora-cg__video'; v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.preload = 'metadata';
          if (g.dataset.poster) v.poster = g.dataset.poster;
          v.src = g.dataset.video; g.appendChild(v);
        }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (v) { v.pause(); }
    });
  }, { rootMargin: '150px 0px', threshold: 0.2 }) : null;

  function applyOne(g) {
    var t = g.querySelector('.dora-cg__track'); if (!t) return;
    if (g.__dv === view && t.clientWidth) return; // già impostata: non toccare lo scorrimento fatto dalla cliente
    g.__dv = view;
    var hasVideo = !!g.dataset.video;
    g.classList.toggle('is-video', view === 'video' && hasVideo);
    if (view === 'video' && hasVideo) { if (vio) vio.observe(g); }
    else {
      if (vio) vio.unobserve(g);
      var v = g.querySelector('video.dora-cg__video'); if (v) { v.pause(); }
      // in "Indossato" (e nei capi senza video in "Video") si parte dalla seconda foto
      var target = (view === 'model' || view === 'video') && t.children.length > 1 ? t.clientWidth : 0;
      if (Math.abs(t.scrollLeft - target) > 2) t.scrollLeft = target;
      if (target) { var img = t.children[1] && t.children[1].querySelector('img'); if (img) img.loading = 'eager'; }
    }
  }
  function applyAll() {
    document.documentElement.setAttribute('data-dora-view', view);
    var any = false;
    document.querySelectorAll('[data-dora-cg]').forEach(function (g) { applyOne(g); if (g.dataset.video) any = true; });
    document.querySelectorAll('[data-dora-view]').forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      var on = b.getAttribute('data-dora-view') === view;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.getAttribute('data-dora-view') === 'video') b.hidden = !any;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-dora-view]'); if (!b) return;
    view = b.getAttribute('data-dora-view');
    try { localStorage.setItem(KEY, view); } catch (err) {}
    try { sessionStorage.setItem('doraCgHint', '1'); } catch (err) {}
    applyAll();
  });
  var pend = 0;
  new MutationObserver(function () {
    if (pend) return; pend = requestAnimationFrame(function () { pend = 0; applyAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll); else applyAll();
  window.addEventListener('load', applyAll);
})();
